import React from "react";
import DeviceTable from "../components/DeviceTable";
import DeviceSearch from "../components/DeviceSearch";
const Devices = () => {
  return <DeviceTable />;
};
export default Devices;
